import './App.css';
import Layout from './components/layout/Layout';

function App(argument) {
	return(
		<>
		<Layout></Layout>
		</>
	);
}

export default App;

